import { type Locale, format, formatRelative } from "date-fns";
import { enUS, fr } from "date-fns/locale";
import { cn } from "../../../lib/utils";
import { Tooltip, TooltipContent, TooltipTrigger } from "../../tooltip";
import type { DateCellProps } from "../types";
import { EmptyCell } from "./EmptyCell";

const localeMap: Record<string, Locale> = {
  fr_FR: fr,
  en_US: enUS,
};

export const DateCell: React.FC<DateCellProps> = ({
  value,
  locale = "en_US",
  className,
  showTooltip = true,
}) => {
  if (!value) {
    return <EmptyCell className={cn("text-body", className)} />;
  }

  const date = value instanceof Date ? value : new Date(value);
  const relative = formatRelative(date, new Date(), {
    locale: localeMap[locale] || enUS,
  });

  const content = (
    <span className={cn("text-body cursor-default", className)}>
      {relative}
    </span>
  );
  const exact = format(date, "Pp", { locale: localeMap[locale] || enUS });

  return showTooltip ? (
    <Tooltip>
      <TooltipTrigger asChild>{content}</TooltipTrigger>
      <TooltipContent className="z-[9999]">{exact}</TooltipContent>
    </Tooltip>
  ) : (
    content
  );
};
